import type {
  AssetAttributesInfo,
  AssetInfo,
  AssetInspectionInfo,
  AssetInspectionRecord,
} from 'actions/asset';

export type AssetHubModalDetails =
  | null
  | ReadonlyArray<AssetAttributesInfo>
  | AssetInfo
  | AssetInspectionInfo
  | AssetInspectionRecord
  | { readonly message: string }
  | Readonly<Record<string, unknown>>;

export function getUnknownErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  return typeof error === 'string' ? error : 'Unknown error';
}
